import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const loggedIn = this.authenticationService.isLoggedIn();
        if (!loggedIn) {
          this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
          return false;
        }
        return true;
    }
      
      
}
